import React, { useEffect, useRef } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  // Handle ESC key to close
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      // Prevent body scrolling when modal is open
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  // Handle click outside to close
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-in fade-in duration-200" onClick={handleBackdropClick} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-61">
      <div ref={modalRef} className="relative w-full max-w-3xl max-h-[90vh] bg-slate-800 rounded-2xl shadow-2xl border border-slate-700 flex flex-col animate-in zoom-in-95 duration-200" data-id="element-62">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-700" data-id="element-63">
          <h2 id="modal-title" className="text-2xl font-bold text-white" data-id="element-64">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 text-slate-400 hover:text-white hover:bg-slate-700 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500" aria-label="Cerrar modal" data-id="element-65">
            <XIcon className="w-6 h-6" data-id="element-66" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto custom-scrollbar" data-id="element-67">
          <div className="prose prose-invert max-w-none text-slate-300" data-id="element-68">
            {children}
          </div>
        </div>
      </div>
    </div>;
}